export enum AlertDialogButtons {
  REVOKE = 'Revoke',
  RE_INVITE = 'Re-Invite',
  DELETE = 'Delete',
  RUN_WORKFLOW = 'Run Now',
  ADD_DESTINATION = 'Add Destination',
  PROCESSING_WORKFLOW = 'Processing',
  CONTINUE = 'Continue',
  REMOVE = 'Remove',
  VIEW_DETAILS = 'View Details',
  RE_RUN_SINGLE_STEP = 'Start Run',
  RE_RUN_ALL_STEPS = 'Re-run All Steps',
  DUPLICATE = 'Duplicate',
  PUBLISH_DRAFT = 'Publish Draft'
}

export enum AlertDialogTitle {
  INVITATION_REVOKE = 'Revoke invitation?',
  INVITATION_RESEND = 'Send re-invitation email?',
  DELETE_ORGANIZATION = 'Delete this Organization?',
  REMOVE_USER = 'Remove this user?',
  DELETE_CREDENTIAL = 'Delete this credentials?',
  RUN_WORKFLOW = 'Run Workflow?',
  PROCESSING_WORKFLOW = 'is currently running',
  DELETE_WORKFLOW = 'Delete Workflow',
  REMOVE_DESTINATION = 'Remove this Destination?',
  DETAILS = 'Details',
  RE_RUN_SINGLE_STEP = 'Re-run this step?',
  RE_RUN_ALL_STEPS = 'Re-Run all steps for this Workflow?',
  DUPLICATE = 'Duplicate this Workflow?',
  PUBLISH_DRAFT = 'Publish'
}

export enum AlertDialogDescription {
  INVITATION_REVOKE = 'You are about to revoke the invitation to this user.',
  INVITATION_RESEND = 'You are about to send a re-invitation email to this user.',
  REMOVE_USER = 'You are about to delete a user from this organization.',
  DELETE_CREDENTIAL = 'You are about to delete this credential. This process cannot be undone.',
  RUN_WORKFLOW = 'You are about to run this workflow.',
  PROCESSING_WORKFLOW = `Running a workflow usually takes 15 minutes or more. You can close this window and continue what you are doing.`,
  DELETE_WORKFLOW = 'You are about to permanently delete this workflow.',
  REMOVE_DESTINATION = 'Are you sure you want to remove this destination?',
  RE_RUN_SINGLE_STEP = 'This action will re-run the selected workflow step. If you enable the option, all subsequent steps in the workflow will also be re-run in sequence.',
  RE_RUN_LAST_STEP = 'You are about to re-run the last step of this workflow.',
  RE_RUN_ALL_STEPS = 'You are about to rerun all steps for this workflow.',
  DUPLICATE = 'You are about to create a duplicate of this workflow',
  PUBLISH_DRAFT = 'You are about to publish this draft workflow. This will make this workflow active and ready to run.'
}
